import React from 'react';
import '../App.css';

// NOTE: This page used old SQLite-based components (TaskList, TeamList, TeamTasks)
// which have been removed. This page is kept for reference but is not functional.
// Use ReleaseAdminPage instead.

function AdminPage() {
  return (
    <div className="App">
      <h1>Task Tracker - Admin Page</h1>
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <p>This page is deprecated. Please use the Release Admin Page instead.</p>
        <p>
          <a href="/releaseAdmin">Go to Release Admin Page</a>
        </p>
      </div>
    </div>
  );
}

export default AdminPage;
